import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import SampleTypeCollection from "@/collections/lab/SampleTypeCollection";
import PrepTaskCollection from "@/collections/lab/PrepTaskCollection";
import PrepWorkflowCollection from "@/collections/lab/PrepWorkflowCollection";
import SampleCollection from "@/collections/lab/SampleCollection";

export default class PrepProcessModel extends LabServiceModel {
  modelName() {
    return 'prep-process';
  }
  icon() {
    return 'puzzle-piece';
  }
  isPrep() {
    return true;
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      sample_type_id: null,
      sample_type: null,
      name: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      prep_tasks: {},
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }
  validation() {
    return {}
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }
  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }
  getPrepWorkflows() {
    return this.getRelatedCollection(new PrepWorkflowCollection(), 'prep_workflows');
  }
  getPrepTasks() {
    return this.getRelatedCollection(new PrepTaskCollection(), 'prep_tasks');
  }
  getSchedulableTasks() {
    return this.getRelatedCollection(new PrepTaskCollection(), 'schedulable_tasks');
  }
  getAllocatableSamples() {
    return this.getRelatedCollection(new SampleCollection(), 'allocatable_samples');
  }
}
